import { Grid, GridItem } from "@chakra-ui/react";
import React from "react";
import ChatBox from "../ChatBox/ChatBox";
import LoanOfficerMain from "./LoanOfficerMain";
import LoanOfficerSidebar from "./LoanOfficerSidebar";

const LoanOfficer = () => {
  return (
    <div>
      <Grid
        templateColumns={{ base: "repeat(1, 1fr)", md: "7% 58% 30%" }}
        gap={2}
        minH="100vh"
        alignItems="stretch"
        mt={10}
      >
        <GridItem h="100%" py={4} ml={7}>
          <div className="relative">
            <LoanOfficerSidebar />
          </div>
        </GridItem>
        <GridItem w="100%" paddingX={4}>
          <LoanOfficerMain />
        </GridItem>
        <GridItem w="100%" h="100%" p={4} mr={10}>
          <div className="relative h-full">
            <div className="fixed top-[100px] h-full">
              <ChatBox isAtlasTextNeeded={true} />
            </div>
          </div>
        </GridItem>
      </Grid>
    </div>
  );
};

export default LoanOfficer;
